import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Input, Select, DatePicker, Radio, Checkbox, Collapse, notification, Divider } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Tabs } from 'antd';
import { EnvironmentOutlined, AuditOutlined, HomeOutlined, FileProtectOutlined, DollarCircleOutlined } from '@ant-design/icons';


import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { servicioCreateAction, servicioReadAction } from '../../../redux/administracion/servicios/actionCreator';
import {
  estadosListAction, municipioListAction, sucursalEsquemasContractualesListAction, sucursalEsquemasCostosListAction
} from '../../../redux/catalogos/actionCreator';
import moment from 'moment';


const dateFormat = 'YYYY-MM-DD';

const ServicioMainForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const catalogoCategorias = useSelector(state => state.CatalogosReducer.categoriasServicios);
  const catalogoTipos = useSelector(state => state.CatalogosReducer.tiposServicio);
  const registro = useSelector(state => state.ServicioReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams();
  const [form] = Form.useForm();

  useEffect(() => {
    if (id)
      dispatch(servicioReadAction(id));
    else {
      dispatch(servicioReadAction());
      form.resetFields();
    }
  }, [id]);


  useEffect(() => {
    console.log('servicio? ', registro.servicio)
    form.resetFields();
    if (registro?.servicio?.id) {
      if (registro.precios) {
        form.setFieldsValue(
          {
            id: registro.servicio.id,
            idCategoria: registro.servicio.idCategoria,
            nombre: registro.servicio.nombre,
            low_precio_base: registro.precios[0].precio_base ?? '',
            low_precio_pad: registro.precios[0].precio_pad ?? '',
            low_monto_requerido_anticipo: registro.precios[0].monto_requerido_anticipo ?? '',
            low_porcentaje_maximo_descuento: registro.precios[0].porcentaje_maximo_descuento ?? '',
            sta_precio_base: registro.precios[1].precio_base ?? '',
            sta_precio_pad: registro.precios[1].precio_pad ?? '',
            sta_monto_requerido_anticipo: registro.precios[1].monto_requerido_anticipo ?? '',
            sta_porcentaje_maximo_descuento: registro.precios[1].porcentaje_maximo_descuento ?? '',
          }
        );
      } else {
        form.setFieldsValue(
          {
            id: registro.servicio.id,
            idCategoria: registro.servicio.idCategoria,
            nombre: registro.servicio.nombre
          }
        );

      }
    }
  }, [form, registro]);


  const handleSubmit = async (values) => {
    let action = 'create';
    if (id) {
      action = 'update';
    }
    const responseApi = await dispatch(servicioCreateAction({
      ...values,
      action: action
    }));
    if (responseApi) {
      let mensaje = 'Servicio creado exitosamente';
      if (action === "update") mensaje = 'Servicio actualizado exitosamente';
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      history.replace('/admin/servicios/listado');
    } else {
      notification.error({
        message: 'Error al gestionar servicio',
      });
    }
  };

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/servicios/listado">Ver todos</Link>
          </Button>,
        ]}
        ghost
        title='FICHA DE DATOS DEL SERVICIO'
      />
      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            <Form
              className="add-record-form"
              style={{ width: '100%' }}
              layout="horizontal"
              size="small"
              form={form}
              name="addnew"
              onFinish={handleSubmit}
            >
              <RecordFormWrapper>
                <Cards headless>
                  <Divider orientation='right' plain>DATOS GENERALES <AuditOutlined style={{ fontSize: '16px' }} /></Divider>

                  <BasicFormWrapper>
                    <Form.Item name="id" initialValue="0">
                      <Input hidden />
                    </Form.Item>
                    <Form.Item name="idCategoria" label="Categoria" rules={[{ required: false }]}>
                      <Select placeholder="Selecciona..." options={catalogoCategorias} notFoundContent={'Sin registros'} />
                    </Form.Item>
                    <Form.Item name="nombre" label="Nombre del servicio" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="Ej. Profilaxis" />
                    </Form.Item>
                    <Form.Item name="costo" label="Costo" rules={[{ message: 'Campo obligatorio', required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    {/*<Form.Item name="tipo" label="Tipo" rules={[{ required: false }]}>
                      <Select placeholder="Selecciona..." options={catalogoTipos} notFoundContent={'Sin registros'} />
      </Form.Item>*/}
                  </BasicFormWrapper>

                  <Divider orientation='right' plain>PRECIOS VIGENTES <DollarCircleOutlined style={{ fontSize: '16px' }} /></Divider>
                  <BasicFormWrapper>
                    <table style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th>Esquema costos</th>
                          <th>Precio normal</th>
                          <th>Precio PAD</th>
                          <th>Pago inicial requerido</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Low cost</td>
                          <td>
                            <Form.Item name="low_precio_base"><Input /></Form.Item>
                          </td>
                          <td>
                            <Form.Item name="low_precio_pad"><Input /></Form.Item>
                          </td>
                          <td>
                            <Form.Item name="low_monto_requerido_anticipo"><Input /></Form.Item>
                          </td>
                        </tr>
                        <tr>
                          <td>Standard</td>
                          <td>
                            <Form.Item name="sta_precio_base"><Input /></Form.Item>
                          </td>
                          <td>
                            <Form.Item name="sta_precio_pad"><Input /></Form.Item>
                          </td>
                          <td>
                            <Form.Item name="sta_monto_requerido_anticipo"><Input /></Form.Item>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </BasicFormWrapper>


                  <br />
                  <div className="record-form-actions text-right">
                    <Button size="default" htmlType="Save" type="primary">
                      {isLoading ? 'Cargando...' : 'Guardar'}
                    </Button>
                  </div>
                </Cards>
              </RecordFormWrapper>
            </Form>

          </Col>
        </Row>
      </Main>
    </>
  );
};

export default ServicioMainForm;
